import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { NavbarUser } from './app-navbar-user';
import { buildLogo, dropdownForLangs } from './app-navbar-utils';
export var AppNavbar = function (_a) {
    var i18nLangs = _a.i18nLangs, exitButton = _a.exitButton, currentLangKey = _a.currentLangKey, onLangChange = _a.onLangChange, navbarItemsRight = _a.navbarItemsRight, isAuthenticated = _a.isAuthenticated, onSidebarHandlerClick = _a.onSidebarHandlerClick, user = _a.user, logo = _a.logo, customerPortalButton = _a.customerPortalButton;
    var buildToggleButton = function (callback) {
        var handleClick = function () { return callback(); };
        return (React.createElement("div", { className: 'd-flex navbar-border navbar-content-align', onClick: handleClick },
            React.createElement(FontAwesomeIcon, { icon: faBars, size: '2x', className: 'text-white' })));
    };
    return (React.createElement(Navbar, { bg: 'dark', variant: 'dark', expand: 'md', className: 'app-navbar' },
        isAuthenticated ? buildToggleButton(onSidebarHandlerClick) : null,
        React.createElement("div", { style: { maxWidth: 260, marginLeft: '1rem', marginRight: '2rem', overflow: 'hidden' }, className: 'd-flex align-items-center navbar-border' }, buildLogo(logo)),
        React.createElement(Nav, { className: 'ml-auto d-flex align-items-center' },
            isAuthenticated && navbarItemsRight ? navbarItemsRight.map(function (item) { return item; }) : null,
            isAuthenticated && user ? React.createElement(NavbarUser, { user: user }) : null,
            dropdownForLangs(i18nLangs, currentLangKey, onLangChange),
            isAuthenticated && customerPortalButton ? customerPortalButton : null,
            isAuthenticated && exitButton ? exitButton : null)));
};
//# sourceMappingURL=app-navbar.js.map